export default __webpack_public_path__ + "static/media/qr-google.a1b526e1.svg";